module.exports = __webpack_public_path__ + "img/MYR.d21a2ae3.svg";